import * as _ from "lodash";
import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let AppointmentDateComponent = {
    selector: "vcAppointmentDate",
    templateUrl: "/angular/components/planner/appointment-date.component.html",
    bindings: {
        date: "=?",
    },
    controller: class DateRangeController {
        // * bindings for typescript compiler *
        public date?: Date;
        // ************************************
        private dialog: DialogUtils;
        private preferencesService: any;

        public use24hr: boolean = false;
        public periods: string[];
        public hours: number[];
        public readonly minutes = [
            "00",
            "05",
            10,
            15,
            20,
            25,
            30,
            35,
            40,
            45,
            50,
            55,
        ];
        public readonly days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ];

        public today: Date;
        public start: any;

        constructor(DialogUtils: DialogUtils, PreferencesService: any) {
            this.dialog = DialogUtils;
            this.preferencesService = PreferencesService;
            this.use24hr = PreferencesService.use24Hour();
            this.periods = this.use24hr ? [""] : ["am", "pm"];
            this.hours = this.use24hr
                ? [
                      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                      17, 18, 19, 20, 21, 22, 23,
                  ]
                : [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
            this.today = new Date();
        }

        formatTimeOption(hour: number, minute: any, period: string): string {
            if (this.use24hr) {
                const h = hour < 10 ? "0" + hour : hour.toString();
                return h + ":" + minute;
            }
            return hour + ":" + minute + period;
        }

        $onInit() {
            if (this.date) {
                const date = new Date(this.date);
                let startHour = date.getHours();
                let mins = date.getMinutes();
                let startMins = mins + 5 - (mins % 5);
                if (startMins == 60) {
                    startMins = 0;
                    startHour++;
                }

                if (this.use24hr) {
                    this.start = {
                        date: _.cloneDeep(date),
                        time: {
                            period: "",
                            hours: startHour,
                            minutes: startMins,
                            model: this.formatTimeOption(
                                startHour,
                                startMins,
                                ""
                            ),
                        },
                    };
                } else {
                    let startHourModel =
                        startHour > 12 ? startHour - 12 : startHour;
                    let startPeriod = startHour >= 12 ? "pm" : "am";

                    this.start = {
                        date: _.cloneDeep(date),
                        time: {
                            period: startPeriod,
                            hours: startHour,
                            minutes: startMins,
                            model:
                                startHourModel + ":" + startMins + startPeriod,
                        },
                    };
                }
                this.timeChanged(
                    this.start,
                    this.start.time.period,
                    this.start.time.hours,
                    this.start.time.minutes
                );
            }
        }

        timeChanged(
            obj: any,
            period: string,
            hour: number,
            minute: number,
            ignorePeriod?: boolean
        ): void {
            if (this.use24hr) {
                obj.date.setHours(hour, minute, 0, 0);
                obj.time.hours = hour;
                obj.time.minutes = minute;
                obj.time.period = "";
            } else {
                if (!ignorePeriod) {
                    if (hour === 12) {
                        hour = 0;
                    }
                    if (period === "pm" && hour < 13) {
                        hour = hour + 12;
                    }
                }

                obj.date.setHours(hour, minute, 0, 0);

                obj.time.hours = hour;
                obj.time.minutes = minute;
                obj.time.period = period;
            }
        }
        save(): void {
            this.dialog.hide(this.start);
        }
        dismissDialog(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("planner")
    .component(AppointmentDateComponent.selector, AppointmentDateComponent);
